import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Kicker } from "@/components/Reveal";

export default function CtaBand({
  title = "Bring Faith to Life Through Art.",
  copy = "Explore the collection, connect with the artist, or begin your own creative journey.",
}) {
  return (
    <section className="divine-rays-dark relative overflow-hidden bg-[#171310] py-24 md:py-32" data-testid="cta-band">
      <div className="pointer-events-none absolute left-1/2 top-0 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-[#D4AF37]/10 blur-3xl" />
      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6">
        <Reveal>
          <Kicker className="justify-center">Begin Your Journey</Kicker>
          <h2 className="mt-6 font-serif text-3xl font-normal tracking-tight text-[#FAF7F2] sm:text-5xl">
            {title}
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base font-light leading-relaxed text-[#B7AA99]">
            {copy}
          </p>
          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/portfolio" className="btn-gold" data-testid="cta-explore-art">
              Explore the Art <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/booking" className="btn-ghost-light" data-testid="cta-book-consultation">
              Book a Consultation
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
